import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ErrorEffects } from './+state/ngrx-error.effects';
import { NgrxErrorFacade } from './+state/ngrx-error.facade';
import * as fromState from './+state/ngrx-error.reducer';
import { ApiErrorInterceptor } from './api-error.interceptor';
import { ErrorConfig } from './error.config';
import { GlobalErrorHandler } from './global-error-handler.service';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromState.ERROR_FEATURE_KEY, fromState.reducer),
    EffectsModule.forFeature([ErrorEffects]),
  ],
})
export class AppErrorModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: AppErrorModule
  ) {
    if (parentModule) {
      throw new Error(
        'AppErrorModule is already loaded. Import only in AppModule'
      );
    }
  }

  static forRoot(config: ErrorConfig): ModuleWithProviders<AppErrorModule> {
    return {
      ngModule: AppErrorModule,
      providers: [
        NgrxErrorFacade,
        {
          // processes all errors
          provide: ErrorHandler,
          useClass: GlobalErrorHandler,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ApiErrorInterceptor,
          multi: true,
        },
        {
          provide: ErrorConfig,
          useValue: config,
        },
      ],
    };
  }
}
